import { OutBound, OutBoundKeyword } from 'core/brand/Brand';
import IconWithTooltip from 'components/IconWithTooltip/IconWithTooltip';
import styles from './outboundKeywordCreatives.module.scss';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';
import { Section } from 'components/Rsuite/Section';
import { Input, Toggle, Form } from 'rsuite';
import { RsSelect } from 'components/Rsuite/Select';
import fbLogo from 'assets/outbound/fb.svg';
import messageCircle from 'assets/outbound/messageCircle.svg';
import messager from 'assets/outbound/messager.svg';
import plus from 'assets/outbound/plus.svg';
import search from 'assets/outbound/search.svg';
import thumbsUp from 'assets/outbound/thumbsUp.svg';
import vector from 'assets/outbound/Vector.svg';
import vectorCicle from 'assets/outbound/vectorCicle.svg';
import vectorEarth from 'assets/outbound/vectorEarth.svg';
import clothesImage from 'assets/outboundKeyword/T-Shirt.svg';
import { OutboundKeywordInfo, Goal } from '../../Hooks/useOutboundKeywordForm';
import InfoOutlineIcon from '@rsuite/icons/InfoOutline';
import facebookLogo from 'assets/outboundKeyword/facebook_logo.svg';
import instagramLogo from 'assets/outboundKeyword/instagram_logo.svg';
import googleLogo from 'assets/outboundKeyword/google_small_logo.svg';
import externalLink from 'assets/external-link.svg';
import maximize from 'assets/maximize.svg';
import minimize from 'assets/minimize.svg';
import Skeleton from 'react-loading-skeleton';

interface Iprops {
  outboundBrandOptions?: OutBoundKeyword[];
  defaultForm: any;
  outboundInfo: OutboundKeywordInfo;
  errorMessage: string;
  adContentMessage: string;
  webBrandNo: string;
  selectPattern: string;
  changeOutbound: (selectedOption: any) => void;
  changeAdContent: (e: string) => void;
}
const initialOutBoundInfo: OutboundKeywordInfo = {
  brandNo: '',
  brandName: '',
  name: '',
  logoUrl: '',
  adContent: '',
  segment: [],
  goal: Goal.LINK_CLICKS,
};

export const OutBound_default_AdContent = `momo 全站限時優惠\n熱門商品特價中\n立即加入購物車！`;

const OutboundKeywordCreatives: React.FC<Iprops> = ({
  outboundBrandOptions = [],
  errorMessage,
  adContentMessage,
  changeAdContent,
  outboundInfo = initialOutBoundInfo,
  changeOutbound,
  defaultForm,
  webBrandNo,
  selectPattern,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isPreviewExpanded, setIsPreviewExpanded] = useState(false);
  const [loading, setLoading] = useState(true);

  // 修改站外聯播網主要文字
  const changeOutsideText = (e: string) => {
    // console.log(e)
    setIsExpanded(false);
    changeAdContent(e);
  };

  // 客製 "Meta 廣告投放帳號" 下拉選單的內容
  const renderMenuItem = (label, item) => {
    return (
      <section className='flex items-center gap-2'>
        <img
          src={item?.logoUrl}
          width={40}
          height={40}
          alt=''
          className='rounded-full'
        />
        {label}
        {/* {!item.available && (
          <span className='text-red-500'>
            該品牌下您所選擇的商品不足2品，無法投遞 Meta 廣告
          </span>
        )} */}
      </section>
    );
  };

  const renderValue = (_, item) => {
    if (!item) return <div className='text-[#808080]'>請選擇</div>;
    return (
      <section className='flex items-center gap-2'>
        {item?.logoUrl && (
          <img
            src={item?.logoUrl}
            width={30}
            height={30}
            alt=''
            className='rounded-full'
          />
        )}

        <span className='mb-[2px]'>{item?.brandName}</span>
      </section>
    );
  };

  // 顯示更多的文字
  const renderText = () => {
    if (isExpanded) {
      return outboundInfo.adContent;
    }
    const lines = outboundInfo.adContent
      ? outboundInfo.adContent.split('\n')
      : [];
    if (lines.length > 3) {
      return lines.slice(0, 3).join('\n');
    }
    return outboundInfo.adContent;
  };

  // 手機模擬-顯示更多是否展開的參數
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const togglePreviewExpand = () => {
    setIsPreviewExpanded(!isPreviewExpanded);
  };

  useEffect(() => {
    // 模擬加載完成
    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`ml-[113px] ${styles.component} `}>
      <div className={styles['left-section']}>
        <div className=''>
          <fieldset>
            <legend>
              <span>商品設定</span>
            </legend>
            <span className={styles.hint}>
              系統為您自動挑選潛力商品，助您達成最大化流量與轉換；系統將以您所選的品牌名稱與
              Logo 建立 Meta 投放廣告帳號
            </span>

            <Form.Group>
              {defaultForm?.basic?.outboundInfo?.brandName ? (
                <div className='mt-[10px] flex h-[42px] w-[560px] items-center gap-[8px] rounded border border-solid border-[#D9D9D9] bg-[#D9D9D9] p-[7px] font-bold text-[#404040]'>
                  <img
                    src={defaultForm?.basic?.outboundInfo?.logoUrl}
                    width={30}
                    height={30}
                    alt=''
                    className='rounded-full'
                  />

                  {defaultForm?.basic?.outboundInfo?.brandName}
                </div>
              ) : loading ? (
                <Skeleton height={42} width='100%' className='mt-[10px]' />
              ) : (
                <RsSelect
                  className='mt-[10px] w-full'
                  data={outboundBrandOptions}
                  // 只要 defaultForm 已有選品, 就不可再更改站外品牌
                  disabled={
                    defaultForm?.basic?.outboundInfo?.brandNo?.length > 0 ||
                    (selectPattern === 'AUTO' && webBrandNo?.length > 0)
                  }
                  value={outboundInfo.brandNo}
                  onChange={changeOutbound}
                  cleanable={false}
                  renderMenuItem={renderMenuItem}
                  renderValue={renderValue}
                  menuMaxHeight={210}
                />
              )}
              <Form.ErrorMessage
                show={errorMessage !== undefined}
                placement='topStart'
              >
                {errorMessage}
              </Form.ErrorMessage>
            </Form.Group>

            <span className={styles.error_adContent} />
          </fieldset>
        </div>
        <fieldset className={styles.adContent}>
          <legend className='pt-9'>
            <span className='mr-[10px]'>廣告主要文字</span>
            <IconWithTooltip
              icon={faQuestionCircle}
              placement='bottom-start'
              tooltipProps={{
                id: 'tags-hint',
                tooltip: '建議 1-3 行文字，勿超過 80 個字元，請勿輸入任何網址',
              }}
            />
          </legend>
          <span className={styles.hint}>
            此文字僅用於 Meta 廣告投放，不用於其他聯播網渠道。
          </span>
          <Form.Group>
            <Input
              as='textarea'
              rows={3}
              className='mt-[10px] w-full'
              placeholder='請輸入 Meta 廣告主要文字'
              value={outboundInfo.adContent}
              onChange={changeOutsideText}
            />
            <Form.ErrorMessage
              show={adContentMessage !== undefined}
              placement='topStart'
            >
              {adContentMessage}
            </Form.ErrorMessage>
          </Form.Group>
        </fieldset>
      </div>
      <div className={styles['right-section']}>
        <div className='flex flex-col'>
          <div
            className={`${styles['phone-preview']} ${isPreviewExpanded ? styles['expanded'] : ''}`}
          >
            <div
              className={`items-center justify-center rounded-lg bg-[#F7F7FA] p-2 text-xs ${styles['adPreviewBtn']} `}
            >
              <div
                className='flex cursor-pointer items-center'
                onClick={togglePreviewExpand}
              >
                <img
                  src={facebookLogo}
                  width={20}
                  height={20}
                  className='mr-2'
                />
                <p className='mr-2'>廣告預覽</p>
                <img
                  src={isPreviewExpanded ? minimize : maximize}
                  width={16}
                  height={16}
                  className='ml-auto cursor-pointer'
                />
              </div>
              {/* 手機預覽畫面 */}
              <div className={styles.session_right}>
                <div className={styles.container}>
                  <div className={styles.phone}>
                    <div className={styles.header}>
                      <img src={fbLogo} width={64} height={37} alt='' />
                      <div className={styles.tools}>
                        <img src={plus} width={19} height={19} alt='' />
                        <img src={search} width={19} height={19} alt='' />
                        <img src={messager} width={19} height={19} alt='' />
                      </div>
                    </div>
                    <div className={styles.header_title_container}>
                      <div className={styles.header_title_logo}>
                        {outboundInfo.logoUrl && (
                          <img
                            src={outboundInfo.logoUrl}
                            id='header-title-logo'
                            width={20}
                            height={20}
                            alt='typescript'
                          />
                        )}
                      </div>
                      <div className={styles.header_title_body}>
                        <span
                          id='header-title-brandName'
                          className={styles.header_title_brandName}
                        >
                          {outboundInfo.name
                            ? outboundInfo.name
                            : '品牌名稱 - momo購物網'}
                        </span>
                        <div>
                          <span className={styles.header_title_ad}>贊助・</span>
                          <img
                            src={vectorEarth}
                            width={10}
                            height={10}
                            alt=''
                          />
                        </div>
                      </div>
                    </div>
                    <div className={styles.content}>
                      <pre>
                        {renderText()}
                        {outboundInfo.adContent?.split('\n').length > 3 && (
                          <span className={styles.more} onClick={toggleExpand}>
                            {isExpanded ? '' : '.......顯示更多'}
                          </span>
                        )}
                      </pre>
                    </div>

                    <div className={styles.product_container}>
                      <div className={styles.product_list}>
                        <div className={styles.product_item}>
                          <div className={styles.product_item_container}>
                            <div className={styles.product_item_img_container}>
                              <div className={styles.product_item_img}>
                                <img src={clothesImage} alt='' />
                                <span>您所選品牌下的momo商品圖片</span>
                              </div>
                            </div>
                            <div className={styles.product_item_content}>
                              <div className={styles.product_item_info}>
                                <div className={styles.product_item_title}>
                                  momo商品名稱
                                </div>
                                <div
                                  className={styles.product_item_description}
                                >
                                  momo商品描述
                                </div>
                              </div>
                              <div className={styles.product_item_link}>
                                來去逛逛
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.product_item}>
                          <div className={styles.product_item_container}>
                            <div className={styles.product_item_img_container}>
                              <div className={styles.product_item_img}>
                                <img src={clothesImage} alt='' />
                                <span>您所選品牌下的momo商品圖片</span>
                              </div>
                            </div>
                            <div className={styles.product_item_content}>
                              <div className={styles.product_item_info}>
                                <div className={styles.product_item_title}>
                                  momo商品名稱
                                </div>
                                <div
                                  className={styles.product_item_description}
                                >
                                  momo商品描述
                                </div>
                              </div>
                              <div className={styles.product_item_link}>
                                來去逛逛
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.like}>
                      <img src={vector} width={13} height={13} alt='' />
                      <span>777</span>
                    </div>
                    <div className={styles.footer}>
                      <div className={styles.footer_item}>
                        <img src={thumbsUp} width={10} height={10} alt='' />
                        <span>讚</span>
                      </div>
                      <div className={styles.footer_item}>
                        <img
                          src={messageCircle}
                          width={10}
                          height={10}
                          alt=''
                        />
                        <span>留言</span>
                      </div>
                      <div className={styles.footer_item}>
                        <img src={vectorCicle} width={10} height={10} alt='' />
                        <span>分享</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.bg_phone} />
                <div className={styles.notice}>
                  <InfoOutlineIcon width={13} height={13} />
                  廣告的顯示和互動方式可能會因裝置、格式和其他因素而不同
                </div>
              </div>
            </div>
          </div>
          {/* 版位介紹 */}
          <div
            className={`${isPreviewExpanded ? `${styles['adLinkContainer']} ${styles['expand']}` : ''}`}
          >
            <a
              href='https://reurl.cc/LnOvK9'
              className={styles.adLink}
              target='_blank'
              rel='noreferrer'
            >
              <img
                src={instagramLogo}
                width={20}
                height={20}
                className='mr-2'
              />
              版位介紹
              <img src={externalLink} width={16} height={16} className='ml-2' />
            </a>
            <a
              href='https://reurl.cc/NxM5Kq'
              className={styles.adLink}
              target='_blank'
              rel='noreferrer'
            >
              <img src={googleLogo} width={20} height={20} className='mr-2' />
              版位介紹
              <img src={externalLink} width={16} height={16} className='ml-2' />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutboundKeywordCreatives;
